module.exports = __webpack_public_path__ + "img/appltCourse-img20.468ead38.png";